'use client';

import { useEffect } from 'react';
import { setFaviconHref } from '@/components/HtmlHead/utils';
import { useHtmlHeadState } from '../HtmlHeadProvider';

export interface StaticFaviconProps {
    href: string;
}

export function StaticFavicon({ href }: StaticFaviconProps) {
    const { registerBlurHandler, unregisterBlurHandler } = useHtmlHeadState();

    useEffect(() => {
        const blurHandler = () => {
            setFaviconHref(href);

            return undefined;
        };
        registerBlurHandler(blurHandler);

        return () => {
            unregisterBlurHandler(blurHandler);
        };
    }, [href, registerBlurHandler, unregisterBlurHandler]);

    return null;
}
